/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBarcode: {
  name: 'barcode';
  data: string;
} = {
  name: 'barcode',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 1a.5.5 0 0 0-1 0v14a.5.5 0 0 0 1 0V1Zm2 0a.5.5 0 0 0-1 0v9a.5.5 0 0 0 1 0V1Zm12 0a.5.5 0 0 0-1 0v14a.5.5 0 0 0 1 0V1ZM7 .5a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-1 0V1A.5.5 0 0 1 7 .5Zm3.5.5a.5.5 0 0 0-1 0v9a.5.5 0 0 0 1 0V1ZM13 .5a.5.5 0 0 1 .5.5v14a.5.5 0 0 1-1 0V1a.5.5 0 0 1 .5-.5Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
